import { redirect } from '@tanstack/react-router'

import type { FileRoutesByFullPath } from '@/route-tree.gen'

type ModeRoutePath = Extract<keyof FileRoutesByFullPath, `/$country/$language/navigator/${string}`>

export function redirectHome(from: ModeRoutePath) {
  return redirect({
    from,
    to: '/$country/$language/navigator',
  })
}

export function redirectToScene(from: ModeRoutePath, rangeId: string, id: string) {
  return redirect({
    from,
    params: { id, rangeId },
    to: '/$country/$language/navigator/$rangeId/$id',
  })
}
